import React from 'react';
import { useGetFontFaces } from '../queries/fonts';
import defaultFontFaces from '../themes/defaultFontFaces.json';

const useLoadFonts = () => {
  const { data: fonts, isLoading } = useGetFontFaces();

  const loadFonts = fontDefinitions => {
    // Create an array of font loading promises
    const fontPromises = fontDefinitions.map(fontDef => {
      // Create a new FontFace instance
      const fontFace = new FontFace(fontDef.family, fontDef.src, {
        weight: fontDef.weight || 'normal',
      });

      // Load the font and add it to document fonts
      return fontFace.load().then(loadedFace => {
        document.fonts.add(loadedFace);
        return loadedFace;
      });
    });

    // Return a promise that resolves when all fonts are loaded
    return Promise.all(fontPromises);
  };

  React.useEffect(() => {
    loadFonts(defaultFontFaces).catch(error => {
      console.error('Error loading fonts:', error);
    });
    if (!isLoading && fonts && fonts.length > 0) {
      // Load the fonts using the FontFace API
      loadFonts(fonts).catch(error => {
        console.error('Error loading fonts:', error);
      });
    }
  }, [fonts, isLoading]);
};

export default useLoadFonts;
